import { useState } from "react";
import { useMediaQuery } from "@/hooks/use-media-query";
import { local } from "@/lib/storage";

const KEY = "esi:knowledge-panel";
/** Without a choice, the panel is docked only where the thread, sidebar and panel all fit. */
export const KNOWLEDGE_PANEL_ROOM = "(min-width: 1440px)";

type Choice = "shown" | "hidden";
const read = (): Choice | null => {
  const kept = local.get(KEY);
  return kept === "shown" || kept === "hidden" ? kept : null;
};

/**
 * Whether the knowledge panel is docked beside a conversation on a wide screen (spec `web-shell`
 * "Knowledge panel default and remembered state"): the user's one choice, per browser and for
 * every project, else the width default, which follows the window as it resizes. Read once per
 * mount; unavailable storage keeps the choice for this page only.
 */
export function useKnowledgePanel(): { shown: boolean; set: (shown: boolean) => void } {
  const [choice, setChoice] = useState(read);
  const room = useMediaQuery(KNOWLEDGE_PANEL_ROOM);
  return {
    shown: choice === null ? room : choice === "shown",
    set: (shown) => {
      const next: Choice = shown ? "shown" : "hidden";
      setChoice(next);
      local.set(KEY, next);
    },
  };
}
